import { TDisclosureState, DisclosureAction } from "./disclosure.state";
import { NormalizedDisclosure } from "~/types/search.types";
import { SearchActions } from "~/types/actions.enum";

// ✅ Disclosure reducer logic
export const disclosureReducer = (
    state: TDisclosureState,
    action: DisclosureAction
): TDisclosureState => {
    switch (action.type) {
        case SearchActions.SET_DISCLOSURE_ITEMS: {
            return { ...state, disclosures: action.payload };
        }

        case SearchActions.SET_ACTIVE_DISCLOSURE: {
            const isAllDisclosuresAvailable = action.payload?.id === -1;

            return {
                ...state,
                ...(isAllDisclosuresAvailable && { isAllDisclosuresAvailable: action.payload }),
                disclosure: action.payload
            };
        }

        case SearchActions.SET_ACTIVE_DISCLOSURE_BY_KEY: {
            const { property, value } = action.payload;
            const disclosureItem =
                state.disclosures.find((item: NormalizedDisclosure) => item[property] === value) ??
                null;
            const isAllDisclosuresAvailable = disclosureItem?.id === -1;

            return {
                ...state,
                isAllDisclosuresAvailable: isAllDisclosuresAvailable ? disclosureItem : null,
                disclosure: disclosureItem
            };
        }

        case SearchActions.SET_DISCLOSURE_CATEGORY: {
            const { disclosureId, value, isSelected = true } = action.payload;

            const disclosureItem = state.disclosures.find(item => item.exploreId === disclosureId);
            let tempCategories: number[] = [];

            if (!disclosureItem) {
                return { ...state };
            }

            if (isSelected) {
                tempCategories = [...disclosureItem.selectedCategories, value];
                disclosureItem.selectedCategories = [...new Set(tempCategories)];
            } else {
                tempCategories = disclosureItem.selectedCategories.filter(item => item !== value);
                disclosureItem.selectedCategories = tempCategories;
            }

            const updatedDisclosures = state.disclosures.map(item => {
                if (item.exploreId === disclosureId) {
                    return { ...item, selectedTopicIds: tempCategories };
                }
                return item;
            });

            return { ...state, disclosures: updatedDisclosures };
        }

        case SearchActions.SET_IS_ALL_DISCLOSURES: {
            return {
                ...state,
                isAllDisclosuresAvailable: action.payload,
                disclosure: state.disclosures[0]
            };
        }

        case SearchActions.RESET_DISCLOSURE_CATEGORIES: {
            if (!action.payload) {
                return state;
            }

            const updatedDisclosures = state.disclosures.map(item => ({
                ...item,
                selectedCategories: []
            }));
            return { ...state, disclosures: updatedDisclosures };
        }

        default:
            return state;
    }
};
